import React, { useRef, useState } from 'react';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import ReactPlayer from 'react-player/lazy';
import { SCREEN_TABLET } from '../../config/constants';

import './style.scss';

const VideoWithOverlay = ({ buttonText, desktopVideo, mobileVideo, inView }) => {
  const [videoPlayed, setVideoPlayed] = useState(false);
  const [videoPaused, setVideoPaused] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setVideoPlayed(true);
    videoRef.current.seekTo(0);
  };

  const onVideoEnded = () => {
    const event = document.createEvent('Event');
    event.initEvent('video-ended', true, true);
    document.dispatchEvent(event);
  };

  // on mobile need to have a full width outside of Container
  const { width } = useWindowDimensions();
  const isDesktop = width > SCREEN_TABLET;

  return (
    <div className={`VideoWithOverlay ${isDesktop ? 'container Container' : ''}`}>
      <div>
        <ReactPlayer
          url={isDesktop ? desktopVideo : mobileVideo}
          controls={videoPlayed}
          muted={!videoPlayed}
          width="100%"
          height="100%"
          playsinline
          playing={inView && !videoPaused}
          ref={videoRef}
          onPlay={() => setVideoPaused(false)}
          onPause={() => setVideoPaused(true)}
          onEnded={onVideoEnded}
          config={{
            file: {
              attributes: {
                preload: 'none',
              },
            },
          }}
        />
        {!videoPlayed && (
          <>
            <div className="VideoWithOverlay__overlay" />
            <button
              className="Button Button--primary"
              type="button"
              onClick={handlePlay}
            >
              {buttonText}
              <i className="icon icon-play icon-variant-4" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VideoWithOverlay;
